import React from 'react';
import { StyleProp, StyleSheet, ViewStyle } from 'react-native';
import { DNABox, DNAIcon, DNAIconStyleProps, util } from '@alucio/lux-ui';
import { useMediaQuery } from 'react-responsive';
import colors from '@alucio/lux-ui/src/theming/themes/alucio/colors';
import { thumbnailSizeDimensions } from 'src/hooks/useThumbnailSize/useThumbnailSize';
import {
  MATCH_SLIDE_STATUS,
  usePublisherVersioningState,
} from 'src/state/machines/publisherVersioning/PublisherVersioningProvider';

const S = StyleSheet.create({
  iconContainer: {
    borderRadius: 32,
    width: 32,
    height: 32,
  },
  iconContainerSmallerScreen : {
    borderRadius: 24,
    width: 24,
    height: 24,
  },
})

interface SlideMatchingIconProps {
  pageId: string
}

const SlideMatchingIcon: React.FC<SlideMatchingIconProps> = ({ pageId }) => {
  const { matchSlideStates } = usePublisherVersioningState();
  const isLargeScreen = useMediaQuery({
    query: '(min-width: 1300px)',
  })

  type IconVariantsValues = {
    iconProps: DNAIconStyleProps,
    iconContainerProps: StyleProp<ViewStyle>,
  }
  const iconVariants: Record<MATCH_SLIDE_STATUS, IconVariantsValues> = {
    [MATCH_SLIDE_STATUS.MATCHED]: {
      iconProps: {
        name: 'check',
        size: isLargeScreen ? 'lg' : 'md',
      },
      iconContainerProps: {
        backgroundColor: colors['color-success-500'],
      },
    },
    [MATCH_SLIDE_STATUS.NO_MATCH]: {
      iconProps: {
        name: 'not-equals',
        size: isLargeScreen ? 'lg' : 'md',
      },
      iconContainerProps: {
        backgroundColor: colors['color-gray-400'],
      },
    },
    [MATCH_SLIDE_STATUS.NEEDS_REVIEW]: {
      iconProps: {
        name: 'exclamation-mark',
        size: isLargeScreen ? 'lg' : 'md',
      },
      iconContainerProps: {
        backgroundColor: colors['color-warning-500'],
      },
    },
  }

  if (!matchSlideStates[pageId]) return null;
  const iconVariant = iconVariants[matchSlideStates[pageId].status];

  return (
    <DNABox
      alignX="center"
      alignY="center"
      style={util.mergeStyles(
        undefined,
        { height: isLargeScreen ? thumbnailSizeDimensions.lg.height : thumbnailSizeDimensions.md.height },
      )}
    >
      <DNABox
        alignX="center"
        alignY="center"
        style={util.mergeStyles(
          undefined,
          iconVariant.iconContainerProps,
          isLargeScreen ? S.iconContainer : S.iconContainerSmallerScreen,
        )}
      >
        <DNAIcon.Styled
          appearance="filled"
          {...iconVariant.iconProps}
        />
      </DNABox>
    </DNABox>
  )
}

export default SlideMatchingIcon
